export default __webpack_public_path__ + "static/11_Dog-49fe26befebd876c60898faea1a2b540.png";